import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { OffersBanner } from '../../components/OffersBanner';
import { useOfferBookingFormModalEnabled } from '../../hooks/offerBookingFormModal';
import { getIsAuthenticated } from '../../selectors/newbuilding';
import { TThunkDispatch } from '../../types/redux/thunk';
import { NewbuildingBrokerModalsContext } from '../NewbuildingBrokerModalsProvider';
import { trackOffersBannerClick, trackOffersBannerShow } from './tracking';

export const OffersBannerContainer: React.FC = () => {
  const isOfferBookingFormModalEnabled = useOfferBookingFormModalEnabled();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const dispatch: TThunkDispatch = useDispatch();
  const { loadingPlace, startMicrofrontOpening } = React.useContext(NewbuildingBrokerModalsContext);

  const handleClick = React.useCallback(() => {
    trackOffersBannerClick();

    if (isAuthenticated) {
      startMicrofrontOpening('offersBanner');

      return;
    }

    dispatch(
      requestAuthentication({
        onSuccess: () => () => startMicrofrontOpening('offersBanner'),
      }),
    );
  }, [dispatch, isAuthenticated, startMicrofrontOpening]);

  if (!isOfferBookingFormModalEnabled) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackOffersBannerShow}>
      <OffersBanner loading={loadingPlace === 'offersBanner'} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
